import { getInstance } from '@core/i18n/setup';
const i18next = getInstance({
    ns: ['translation', 'cta'],
});
export default i18next;
